import React from 'react';

interface Props {
  color?: string;
}

/**
 * リスト用右矢印シェブロンアイコン
 * HTMLデザインから抽出
 */
const ChevronRightIcon: React.FC<Props> = ({ color = '#0071e3' }) => (
  <svg
    viewBox="0 0 5 10"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{ width: 10, height: 15 }}
  >
    <polygon
      fill={color}
      points="0 1.23 0 0 5 5 0 10 0 8.77 3.77 5 0 1.23"
    />
  </svg>
);

export default ChevronRightIcon;
